import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const createClinicianEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_CLINICIAN();
  try {
    const response = await apiClient.post(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error posting clinician data: ${error.message}`);
  }
};

export const updateClinicianEndpoint = async (data, clinicianId) => {
  if (!clinicianId) {
    throw new Error("Clinician id is required to update clinician");
  }

  const endpoint = API_ENDPOINTS.UPDATE_CLINICIAN(clinicianId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating clinician: ${error.message}`);
  }
};

export const completeOnboardingEndpoint = async clinicianId => {
  if (!clinicianId) {
    throw new Error("Clinician id is required to complete onboarding");
  }

  const endpoint = API_ENDPOINTS.COMPLETE_ONBOARDING(clinicianId);
  try {
    const response = await apiClient.post(endpoint, {});
    return response.data;
  } catch (error) {
    throw new Error(`Error completing onboarding: ${error.message}`);
  }
};
